import IModel from "../model/applicationForm/IApplicationForm";
import IApplication from "../model/IApplication";
import Application from "../model/Application";
import IRequest from "../dto/origination-v2/IApplicationRequest";
import Request from "../dto/origination-v2/ApplicationRequest";
import ApplicationV3Mapper from "@/module/main/service/ApplicationV3Mapper";
import BaseMapperV2 from "@/module/main/service/BaseMapperV2";
import SourceSystem from "@/module/main/dto/SourceSystemEnum";
import OriginationApplicationClient from "@/module/main/dto/origination-v2/OriginationApplicationClient";
import OriginationApplicationClientType from "@/module/main/dto/origination-v2/OriginationApplicationClientTypeEnum";
import {ExistingClient} from "@/module/main/dto/origination-v2/ExistingClient";
import ApiName from "@/module/api/service/ApiNameEnum";

class OriginationV2Mapper extends BaseMapperV2
{
    readonly VERSION: string = 'v2';
    readonly API_NAME: string = ApiName.ORIGINATION;

    public toCreateRequest(application: IModel): IRequest
    {
        let cuid: number = this.stringToNumber(application.customer.carLoan.cuid) || 0;

        return new Request(
            new OriginationApplicationClient(new ExistingClient(cuid), OriginationApplicationClientType.EXISTING_CLIENT),
            ApplicationV3Mapper.getFinancedSubjectBase(application),
            this.getOriginationContext(application.endpoints),
            SourceSystem.EKIS
        );
    }

    public fromResponse(response: any): IApplication
    {
        let {customerKey, state, stateReason, id, workflowSteps} = response;

        return new Application(customerKey, id, state, stateReason, workflowSteps);
    }
}

export default new OriginationV2Mapper();
